import { Injectable } from '@angular/core';
import { environment } from '../../../environments/current';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  public level: LogLevel = LogLevel.Info;
  public logWithDate = true;
  public logWithLevel = true;

  constructor() {
    const debug = localStorage.getItem('DEBUG');
    if ((debug && debug == '1') || !environment.production) {
      this.level = LogLevel.Debug;
    }
  }

  private log(msg: any, level: LogLevel) {
    let msgOut: string;
    if (this.shouldLog(level)) {
      const dateStr = this.logWithDate ? new Date().toUTCString() + ': ' : '';
      const levelStr = this.logWithLevel ? LogLevel[level] + ' - ' : '';
      if (typeof msg == 'string') {
        msgOut = msg;
      } else {
        msgOut = JSON.stringify(msg);
      }
      if (level > LogLevel.Warning) {
        console.error(dateStr + levelStr + msgOut);
      } else {
        console.log(dateStr + levelStr + msgOut);
      }
    }
  }

  private shouldLog(level: LogLevel): boolean {
    return level >= this.level && level !== LogLevel.Off ? true : false;
  }

  debug(msg: any) {
    this.log(msg, LogLevel.Debug);
  }

  info(msg: any) {
    this.log(msg, LogLevel.Info);
  }

  warning(msg: any) {
    this.log(msg, LogLevel.Warning);
  }

  error(msg: any) {
    this.log(msg, LogLevel.Error);
  }

  critical(msg: any) {
    this.log(msg, LogLevel.Critical);
  }
}

export enum LogLevel {
  NotSet = 0,
  Debug = 1,
  Info = 2,
  Warning = 3,
  Error = 4,
  Critical = 5,
  Off = 6,
}
